import React from "react";
import { Typography } from "@mui/material";
import { Controller, Control, FieldValues } from "react-hook-form";
import { AsyncPaginate, LoadOptions } from "react-select-async-paginate";
import { AsyncPaginateFormFieldStyled } from "./async-paginate-field.styles";

interface AsyncPaginateFormFieldProps {
  id: string;
  label?: string;
  name: string;
  control: Control<any, any>;
  loadOptions: LoadOptions<any, any, any>;
  placeholder?: string;
  defaultValue?: any;
  isClearable?: boolean;
}

const AsyncPaginateFormField: React.FC<AsyncPaginateFormFieldProps> = ({
  id,
  label,
  name,
  control,
  loadOptions,
  placeholder = "Search...",
  defaultValue = "",
  isClearable = true,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
        return (
          <AsyncPaginateFormFieldStyled className="async-field">
            {label && <Typography className="field-label">{label}</Typography>}
            <AsyncPaginate
              key={id}
              id={id}
              loadOptions={loadOptions}
              debounceTimeout={300}
              isClearable={isClearable}
              placeholder={placeholder}
              value={value}
              selectRef={ref}
              onChange={onChange}
              styles={{
                placeholder: (provided) => ({
                  ...provided,
                  color: "lightGray",
                }),
                control: (provided, state) => ({
                  ...provided,
                  borderRadius: "16px",
                  borderWidth: "1px",
                  height: "40px",
                  borderColor: state.isFocused
                    ? "var(--light-blue-gray-color)"
                    : "#ccc",
                  boxShadow: state.isFocused
                    ? "0 0 0 1px var(--light-blue-gray-color)"
                    : "none",
                  "&:hover": {
                    borderColor: state.isFocused
                      ? "var(--light-blue-gray-color)"
                      : "#ccc",
                  },
                }),
              }}
            />
            {error && <Typography color="error">{error.message}</Typography>}
          </AsyncPaginateFormFieldStyled>
        );
      }}
    />
  );
};

export default AsyncPaginateFormField;
